<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Calendario de Citas</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter  v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Tipo:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option value="siempre">Rojo</option>
          <option value="hoy">Blanco</option>
        </select>       
      </search-filter>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo" :href="route('cuadros')">
        <span>Crear</span>
        <span class="hidden md:inline">Nuevo Rojo</span>
      </inertia-link>
      <inertia-link v-if="$page.props.auth.user.rol =='Admin'" class="btn-indigo" :href="route('cuadros')">
        <span>Crear</span>
        <span class="hidden md:inline">Nuevo Blanco</span>
      </inertia-link>
    </div>
    <br>
      <br>
      <!--Info Modal-->
      <div class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50"
        v-if="toggleModalInfo==true">
        <div class="relative mx-auto w-auto max-w-2xl">
        <div class="bg-white w-full rounded shadow-2xl flex flex-col">
        <span>asdasdasdasd</span>
        <button class="rounded bg-green-500 text-white px-6 mt-1 py-2 w-3/12 m-auto mb-3" @click="toggleModalInfo=false">close </button>
        </div>
        </div>
        </div>
      <div v-if="toggleModalInfo== true" class="absolute inset-0 z-40 opacity-25 bg-black"></div>

        <div class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50"
        v-if="toggleModalInfo==true">
        <div class="relative mx-auto w-auto max-w-2xl">
        <div class="bg-white w-full rounded shadow-2xl flex flex-col">
        <span>asdasdasdasd</span>
        <button class="rounded bg-green-500 text-white px-6 mt-1 py-2 w-3/12 m-auto mb-3" @click="toggleModal=false">close </button>
        </div>
        </div>
        </div>
      <div v-if="toggleModal== true" class="absolute inset-0 z-40 opacity-25 bg-black"></div>

       <!--Info Modal-->
        <!--Cita Modal-->
      <div class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50"
        v-if="toggleModal==true">
        <div class="relative mx-auto w-auto max-w-2xl">
        <div class="bg-white w-full rounded shadow-2xl flex flex-col">
        <span>asdasdasdasd</span>
        <button class="rounded bg-green-500 text-white px-6 mt-1 py-2 w-3/12 m-auto mb-3" @click="toggleModal=false">close </button>
        </div>
        </div>
        </div>
      <div v-if="toggleModal== true" class="absolute inset-0 z-40 opacity-25 bg-black"></div>

        <div class="fixed overflow-x-hidden overflow-y-auto inset-0 flex justify-center items-center z-50"
        v-if="toggleModal==true">
        <div class="relative mx-auto w-auto max-w-2xl">
        <div class="bg-white w-full rounded shadow-2xl flex flex-col">
        <span>asdasdasdasd</span>
        <button class="rounded bg-green-500 text-white px-6 mt-1 py-2 w-3/12 m-auto mb-3" @click="toggleModal=false">close </button>
        </div>
        </div>
        </div>
      <div v-if="toggleModal== true" class="absolute inset-0 z-40 opacity-25 bg-black"></div>
      <!--Cita Modal-->
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <FullCalendar :options="calendarOptions" />
  </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import esLocale from '@fullcalendar/core/locales/es';

import interactionPlugin from '@fullcalendar/interaction'

export default {
  metaInfo: { title: 'Calendario de Citas' },
  components: {
    Icon,
    Pagination,
    SearchFilter,
    FullCalendar
  },
  layout: Layout,
  props: {
    filters: Object,
    diarios: Object,
    diariosrojo: Object,
    citas: Object,

  },
  data() {
    return {
      toggleModal: false,
      toggleModalInfo: false,
      calendarOptions: {
        locale: esLocale,
        plugins: [ dayGridPlugin, interactionPlugin ],
        initialView: 'dayGridWeek',
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          right: 'dayGridWeek,dayGridDay' // user can switch between the two
        },
        dateClick: this.handleDateClick,
        eventClick: this.handleEventClick,
        eventDidMount: this.handleDidMountClick,
        events: this.citas
      },
      form: {
        search: this.filters.search,
        trashed: this.filters.trashed,
        tipo: 'Cuadro',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('cuadros'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    handleDateClick: function(arg) {
      alert('date click! ' + arg)
    },
    handleEventClick: function(arg) {
     this.toggleModal=true;
    },
  
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
